interface MoreVerticalIconProps {
  className?: string;
}

export function MoreVerticalIcon({ className = '' }: MoreVerticalIconProps) {
  return (
    <svg
      className={className}
      viewBox="0 0 4 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="2" cy="2" r="1.5" fill="currentColor" />
      <circle cx="2" cy="8" r="1.5" fill="currentColor" />
      <circle cx="2" cy="14" r="1.5" fill="currentColor" />
    </svg>
  );
}
